import React, { Component } from 'react'
import { ReactComponent as RatingStar } from 'svg/rating-star.svg'
import { ReactComponent as ShipmentStar } from 'svg/shipment-star.svg'
import { ReactComponent as ShipmentPickip } from 'svg/pickup.svg'
import { ReactComponent as ShipmentDropoff } from 'svg/dropoff.svg'
import { ReactComponent as ShipmentInfo } from 'svg/shipment-info.svg'
import { ReactComponent as ShipmentPayment } from 'svg/shipment-payment.svg'
import { ReactComponent as Menu } from 'svg/menu.svg'
import { ReactComponent as Close } from 'svg/close.svg'
import { ReactComponent as Check } from 'svg/check.svg'
import { ReactComponent as Lock } from 'svg/lock.svg'
import { ReactComponent as Ban } from 'svg/ban.svg'
import { ReactComponent as Shield } from 'svg/shield.svg'
import { ReactComponent as CompassArrow } from 'svg/compass-arrow.svg'
import { ReactComponent as ChevronRight } from 'svg/chevron-right.svg'
import { ReactComponent as ChevronDivider } from 'svg/chevron-divider.svg'
import { ReactComponent as LogoCircle } from 'svg/logo-circle.svg'
import { ReactComponent as LogoText } from 'svg/logo-text.svg'
import { ReactComponent as Box } from 'svg/box.svg'
import { ReactComponent as NewsPaper } from 'svg/news-paper.svg'
import { ReactComponent as LoadingBar } from 'svg/loading-bar.svg'
import { ReactComponent as Phone } from 'svg/phone.svg'
import { ReactComponent as MapIcon } from 'svg/map.svg'
import { ReactComponent as Caution } from 'svg/caution.svg'
import { ReactComponent as CagTruck } from 'svg/cag-truck.svg'
import { ReactComponent as CagShield } from 'svg/cag-shield.svg'
import { ReactComponent as CagPlusOne } from 'svg/cag-plus-one.svg'
import { ReactComponent as CagCoins } from 'svg/cag-coins.svg'
import { ReactComponent as PaymentCreditCard } from 'svg/payment-cc.svg'
import { ReactComponent as PaymentPaypal } from 'svg/payment-paypal.svg'
import { ReactComponent as PaymentInvoice } from 'svg/payment-invoice.svg'
import { ReactComponent as PortalDrive } from 'svg/drive-portal.svg'
import { ReactComponent as PortalSend } from 'svg/send-portal.svg'
import { ReactComponent as PortalGo } from 'svg/portal-go.svg'
import { ReactComponent as QuestionCircle } from 'svg/question-circle.svg'
import { ReactComponent as VideoCircle } from 'svg/video-circle.svg'
import { ReactComponent as Camera } from 'svg/icon-camera.svg'
import { ReactComponent as Link } from 'svg/icon-hyperlink.svg'
import { ReactComponent as BoxDimensions } from 'svg/box-dimensions.svg'

export default class Icon extends Component {

  getSvg(symbol) {
    switch(symbol) {
      case 'star': return RatingStar
      case 'shipment-star': return ShipmentStar
      case 'shipment-pickup': return ShipmentPickip
      case 'shipment-dropoff': return ShipmentDropoff
      case 'shipment-info': return ShipmentInfo
      case 'shipment-payment': return ShipmentPayment
      case 'menu': return Menu
      case 'close':  return Close
      case 'check': return Check
      case 'lock': return Lock
      case 'ban': return Ban
      case 'shield': return Shield
      case 'compass-arrow': return CompassArrow
      case 'chevron-right': return ChevronRight
      case 'chevron-divider': return ChevronDivider
      case 'logo-circle': return LogoCircle
      case 'logo-text': return LogoText
      case 'box': return Box
      case 'news-paper': return NewsPaper
      case 'loading-bar': return LoadingBar
      case 'phone': return Phone
      case 'map': return MapIcon
      case 'caution': return Caution
      case 'cag-truck': return CagTruck
      case 'cag-shield': return CagShield
      case 'cag-plus-one': return CagPlusOne
      case 'cag-coins': return CagCoins
      case 'payment-cc': return PaymentCreditCard
      case 'payment-paypal': return PaymentPaypal
      case 'payment-invoice': return PaymentInvoice
      case 'portal-drive': return PortalDrive
      case 'portal-send': return PortalSend
      case 'portal-go': return PortalGo
      case 'question-circle': return QuestionCircle
      case 'video-circle': return VideoCircle
      case 'camera': return Camera
      case 'link': return Link
      case 'box-dimensions': return BoxDimensions
      default: return RatingStar
    }
  }

  render() {
    const { symbol, modalOpen, ...props } = this.props
    const SvgIcon = this.getSvg(this.props.symbol)
    
    return <SvgIcon {...props} />
  }
}